import { FunctionComponent, ReactElement, SVGProps } from 'react';
import { Message } from '@messageformat/react';
import { space } from '@op/opds.tokens';
import { ReactComponent as ImageCertFI } from '../../images/certificate_fi.svg';
import { ReactComponent as ImageCertSV } from '../../images/certificate_sv.svg';
import { ReactComponent as ImageCertEN } from '../../images/certificate_en.svg';
import styles from './CompleteAcademy.module.scss';

const CompleteAcademy = (): ReactElement => {
  const locale = (document.documentElement.lang || 'fi').slice(0, 2);

  const getImage = (): ReactElement => {
    const imageMap: Record<string, FunctionComponent<SVGProps<SVGSVGElement>>> = {
      fi: ImageCertFI,
      sv: ImageCertSV,
      en: ImageCertEN,
    };

    const CertificateImage = imageMap[locale] || ImageCertFI;

    return (
      <CertificateImage
        className={`${styles['image-content']} ${styles['certificate-image']}`}
        style={{
          marginTop: space.xxl,
        }}
        aria-hidden="true"
      />
    );
  };

  return (
    <>
      {getImage()}
      <h2 className={styles['title-content']}>
        <Message id="course10.recap.title" />
      </h2>
      <h3 className={styles['title-content']}>
        <Message id="course10.recap.subtitle" />
      </h3>
      <p className={styles['body-content']}>
        <Message id="course10.recap.body" />
      </p>
    </>
  );
};

export default CompleteAcademy;
